import { FC } from 'react';
import {
  SectionBreadcrumbs,
  SectionBreadcrumbsProps,
} from '../../common/SectionBreadcrumbs';
import { ACCESS_GROUP_ROUTES } from './AccessGroups';

export interface AccessGroupBreadcrumbsData {
  name: string;
}

export type AccessGroupBreadcrumbsProps = Omit<
  SectionBreadcrumbsProps<AccessGroupBreadcrumbsData>,
  'routes'
>;

export const AccessGroupBreadcrumbs: FC<AccessGroupBreadcrumbsProps> = (
  props
) => <SectionBreadcrumbs {...props} routes={ACCESS_GROUP_ROUTES} />;
